import React from "react";
import dayjs from "dayjs";

const ThermalPosPrintLayout = ({ data, printedTime }) => {
    const ticketCopies = [
        { title: "(Passenger Copy)" },
        { title: "(Guide Copy)" },
        { title: "(Office Copy)" },
    ];

    return (
        <div className="max-w-sm mx-auto p-4 border border-black bg-white">
            {ticketCopies?.length > 0 &&
                ticketCopies?.map((item, index) => (
                    <div key={index}>
                        <div className="mb-6">
                            <h2 className="text-center text-lg font-bold">
                                {data?.busTitle}
                            </h2>
                            <p className="text-center font-semibold">
                                {data?.from_district} to {data?.to_district}
                            </p>
                            <p className="text-center text-sm font-semibold">
                                {item?.title}
                            </p>

                            <div className="text-sm leading-relaxed font-semibold">
                                <p>Boarding: {data?.from}</p>
                                <p>Journey Dt.: {data?.journeyDate}</p>
                                <p>Coach No.: {data?.tripNumber}</p>
                                <p>Cell No.: {data?.msisdn}</p>
                                <p>Seat: {data?.seats}</p>
                                <p>Ticket No: {data?.ticketNumber}</p>
                                <p className="font-bold mt-2">
                                    Fare: {data?.totalFare}
                                </p>
                            </div>

                            <p className="text-xs mt-3 text-center font-semibold">
                                Printed On:{" "}
                                {dayjs(printedTime).format(
                                    "MM/DD/YYYY hh:mm A"
                                )}{" "}
                                <br />
                                Issued By: {data?.issuedCounter}
                            </p>
                        </div>

                        <div className="text-center text-xs">
                            --------------------------
                        </div>
                    </div>
                ))}
        </div>
    );
};

export default ThermalPosPrintLayout;
